<script setup>
import PlanningKeywordTable from '@frontJs/components/tables/projectManagement/sea/PlanningKeywordTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const {
    tenant,
    googleAdsPlanningKeywordCountries,
    googleAdsPlanningKeywordLanguages,
    googleAdsPlanningKeywordPlanNetworks,
} = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
    googleAdsPlanningKeywordCountries: {
        type: Object,
        required: true,
    },
    googleAdsPlanningKeywordLanguages: {
        type: Array,
        required: true,
    },
    googleAdsPlanningKeywordPlanNetworks: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Mots-clés - Planification - SEA - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - SEA - Planification - Mots-clés
    </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(PlanningKeywordTable, {
                    tenant,
                    googleAdsPlanningKeywordCountries,
                    googleAdsPlanningKeywordLanguages,
                    googleAdsPlanningKeywordPlanNetworks,
                }),
            },
        }"
    />
</template>
